const baseUrl = 'https://iq.bigtime.net/BigtimeData/api/v2';

const fetchOptions = (method, data) => {
	let token = window.localStorage.getItem('bigtime-token');
	let headers = {
	};
	if(method === 'POST' || method === 'PUT') {
		headers['Content-Type'] = 'application/json';
	}
	if(token != null) {
        headers['X-Auth-Token'] = token;
        headers['X-Auth-Realm'] = 'ucsj-uvd-elpi'
	}
	let options = {
		method: method,
		mode: 'cors',
		cache: 'no-cache',
		credentials: 'omit',
		headers: headers,
		redirect: 'follow',
		referrerPolicy: 'no-referrer'
	};
	if(data != null) {
		options.body = JSON.stringify(data);
	}
	return options;
};

export const login = (username, password) => {
	let url = `${baseUrl}/session`;
	let data = {"UserId": username, "Pwd": password};
	return fetch(url, fetchOptions('POST', data)).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
};

export const getProjects = () => {
    console.log("getProjects");
    let url = `${baseUrl}/project`;
	return fetch(url, fetchOptions('GET')).then(response => {
		console.log(url, "response", response);
		if(response.url.indexOf("/Error/NoAccess") >= 0) {
			console.error("no access");
			return new Promise((resolve, reject) => {
				reject('no access');
			});
		}
		return response.json(); // promise
	});
}

export const getTasks = projectId => {
	console.log("getTasks");
	let url = `${baseUrl}/task/listByProject/${projectId}`;
	return fetch(url, fetchOptions('GET')).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
	});
}

export const getEntries = (startDate, endDate, view) => {
    console.log("getEntries", startDate, endDate, view);
	if(view == null) {
		view = "Basic";
	}
    let url = `${baseUrl}/time/Sheet/0`;
	if(startDate == null) {
		startDate = new Date(2021, 3, 4, 6);
	}
	if(endDate == null) {
		endDate = new Date();
	}
    let payload = {"StartDt": startDate, "EndDt": endDate, "View": view};
    return fetch(url, fetchOptions('POST', payload)).then(response => {
		console.log(url, "response", response);
		if(!response.ok) {
			// handle 401 error
			console.error("no access");
			return new Promise((resolve, reject) => {
				reject(response);
			});
		}
		return response.json(); // promise
    });
}

export const deleteEntry = sid => {
    console.log('deleteEntry', sid);
    let url = `${baseUrl}/time/${sid}`;
    return fetch(url, fetchOptions('DELETE')).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
    });
}

export const addEntry = (staffSID, projectSID, taskSID, workDate, hours, notes) => {
    let payload = {
      staffsid: staffSID,
      projectsid: projectSID,
      tasksid: taskSID,
      dt: workDate,
      hours_in: hours,
      notes: notes
    };
    console.log("bigtimeService.addEntry", payload);
    let url = `${baseUrl}/time?MarkSubmitted=false`;
    return fetch(url, fetchOptions('POST', payload)).then(response => {
		console.log(url, "response", response);
		return response.json(); // promise
    });
}

